export enum StatusType {
    Active = 'active',
    Invited = 'invited',
    PendingReview = 'pendingreview',
    Draft = 'draft',
    Default = 'default',
    Unknown = 'unknown',
    Expired = 'expired',
    Rejected = 'rejected',
    NonVerified = 'non-verified',
    PendingApproval = 'pendingapproval',
    Requested = 'requested',
    Confirmed = 'confirmed',
    Scheduled = 'scheduled',
    InProcess = 'in-process',
    Completed = 'completed',
    Cancelled = 'cancelled',
    Submitted = 'submitted',
}
